import { useTranslation } from 'react-i18next';
import { useStore } from '@/contexts/StoreContext';

/**
 * O aviso de anúncios nas páginas de privacidade e de coleta de dados da loja
 * gratuita, depois do texto do lojista: o que os anúncios próprios guardam e,
 * quando o Google vale aqui, que ele só carrega com o aceite. Loja paga não
 * mostra nada (não tem anúncio).
 */
export function AvisoDeAnuncios() {
  const { t } = useTranslation();
  const { store } = useStore();
  if (!store?.ads) return null;
  return (
    <section className="mt-8 rounded-xl border border-border bg-muted/30 p-4 text-sm text-muted-foreground" data-aviso-de-anuncios>
      <h2 className="mb-2 text-base font-semibold text-foreground">{t('store.ads.privacy_title')}</h2>
      <p>{t('store.ads.privacy_house')}</p>
      {store.ads.google && <p className="mt-2">{t('store.ads.privacy_google')}</p>}
      <p className="mt-2">
        <a href="https://hystore.com.br/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
          {t('store.ads.privacy_link')}
        </a>
      </p>
    </section>
  );
}
